import React from "react";
import { Link } from "react-router-dom";

export const DASHBOARD_CRUMB = {
  label: "Dashboard",
  href: "/dashboard",
  icon: "solar:home-smile-angle-outline",
};

export default function Breadcrumb({ items = [] }) {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <nav aria-label="breadcrumb" className="flex-shrink-0">
      <ul className="agent-breadcrumb d-flex align-items-center gap-2 mb-0 flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const icon = item.icon || (index === 0 ? "solar:home-smile-angle-outline" : null);
          const content = (
            <>
              {icon ? <iconify-icon icon={icon} className="icon text-lg"></iconify-icon> : null}
              <span>{item.label}</span>
            </>
          );

          return (
            <React.Fragment key={`${item.label}-${index}`}>
              {index > 0 ? (
                <li className="fw-medium text-secondary-light" aria-hidden="true">
                  -
                </li>
              ) : null}
              <li className={`fw-medium ${isLast ? "agent-breadcrumb__current" : "text-secondary-light"}`}>
                {!isLast && item.href ? (
                  <Link to={item.href} className="d-flex align-items-center gap-1 hover-text-primary text-secondary-light">
                    {content}
                  </Link>
                ) : (
                  <span className="d-flex align-items-center gap-1" aria-current={isLast ? "page" : undefined}>
                    {content}
                  </span>
                )}
              </li>
            </React.Fragment>
          );
        })}
      </ul>
    </nav>
  );
}
